import { c as _c } from "react/compiler-runtime";
import { useContextSelector } from "use-context-selector";
import { FilterLayoutContext } from "@/components/layout/FilterLayoutProvider";
import { topStickyVariants } from "@/styles/utils/sticky";
export function useActivityFeedTableHeaderClassNames() {
  const $ = _c(4);
  const page = useContextSelector(FilterLayoutContext, _temp);
  let t0;
  if ($[0] !== page) {
    t0 = function getVariant() {
      if (!page) {
        return "after-top-nav";
      }
      if (page === "activity") {
        return "after-filter-toolbar";
      }
      return "after-hero-header-toolbar";
    };
    $[0] = page;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getVariant = t0;
  const variant = getVariant();
  let t1;
  if ($[2] !== variant) {
    t1 = topStickyVariants({
      variant,
      tableHeader: true
    });
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(v) {
  return v.page;
}